import _cloneDeep from 'lodash.clonedeep';
import _merge from 'lodash.merge';
import * as ActionTypes from './action-types.constants';
import DEFAULT_PLAYLIST_ITEM from './playlist-item.json';

function getDefaultPlaylistItemState() {
    return _cloneDeep(DEFAULT_PLAYLIST_ITEM);
}

function getDefaultState() {
    const DEFAULT_STATE = {
        "series-path": "",
        "ifi-path": "/ifi-1",
        "configs": []
    }
    return DEFAULT_STATE;
}
const Main = (state = getDefaultState(), action) => {
    let newState = {};

    const { type } = action;

    switch (type) {
        case ActionTypes.INIT:
            (() => {
                const { episodes, seriesPath, ifiPath } = action;
                const configs = episodes.map((episode, index) => {
                    return _merge(getDefaultPlaylistItemState(), episode, {
                        "video": {
                            "videoId": `video${index+1}`,
                            "title": episode.title
                        }
                    });
                })
                newState = {
                    "series-path": seriesPath,
                    "ifi-path": ifiPath,
                    "configs": configs
                }
            })()
            break;
        case ActionTypes.ADD_IFI:
            (() => {
                const { config } = action;
                let newConfigs = [...state.configs];
                const pathname = document.location.pathname.replace(state["series-path"],"");
                let currentIndex = newConfigs.findIndex( item => {
                    if(item.comingsoon === true) {
                        return false;
                    }

                    return item.path === pathname || `${item.path}/` === pathname;
                })
                const insertIndex = currentIndex < 1 ? 1 : currentIndex+1;
                const ifiConfig = _merge(DEFAULT_PLAYLIST_ITEM,config,{
                    isIfi: true,
                    "path": state["ifi-path"],
                    "video": {
                        "videoId": "ifi-1",
                        "title": config.title
                    }
                })
                newConfigs.splice(insertIndex,0,ifiConfig);
                newState = {
                    "configs": newConfigs
                }
            })()
            break;
        default:
            newState = state;
    }
    if (newState !== state) {
        newState = _merge(getDefaultState(), state, newState);
    }
    //console.log("[MediaPlayer Reducers] newState",newState);

    return newState;
}


export default Main